import {Link, Tooltip} from "@mui/material";
import {useNavigate} from "react-router-dom";
import ListView from "../ListView/ListView";
import {DEFAULT_PAGE_SIZE_OPTIONS} from "../../utils/pagination";

const ScopesResolveGrid = ({dataGridProps, loading}) => {
  const navigate = useNavigate();

  const columns = [
    {
      field: "user_email",
      headerName: "Usuario",
      flex: 1,
      minWidth: 180,
      renderCell: (params) => (
        <Link
          component="button"
          underline="hover"
          onClick={() => navigate("/user-form", {state: {id: params.row.user_id}})}
        >
          {params.value}
        </Link>
      )
    },
    {
      field: "tenant_name",
      headerName: "Tenant",
      flex: 0.8,
      minWidth: 120,
      renderCell: (params) => (
        <Link
          component="button"
          underline="hover"
          onClick={() => navigate("/tenant-form", {state: {id: params.row.tenant_id}})}
        >
          {params.value}
        </Link>
      )
    },
    {
      field: "client_name",
      headerName: "Cliente",
      flex: 0.8,
      minWidth: 120,
      renderCell: (params) => (
        <Link
          component="button"
          underline="hover"
          onClick={() => navigate("/client-form", {state: {id: params.row.client_id}})}
        >
          {params.value}
        </Link>
      )
    },
    {
      field: "client_product_name",
      headerName: "Producto (Cliente)",
      flex: 0.8,
      minWidth: 130,
      renderCell: (params) => params.value || "-"
    },
    {
      field: "scope",
      headerName: "Scope",
      flex: 1.2,
      minWidth: 180,
      renderCell: (params) => (
        <Link
          component="button"
          underline="hover"
          onClick={() => navigate("/scope-form", {state: {id: params.row.scope_id}})}
        >
          {params.value}
        </Link>
      )
    },
    {
      field: "role_name",
      headerName: "Rol",
      flex: 0.8,
      minWidth: 120,
      renderCell: (params) => (
        <Link
          component="button"
          underline="hover"
          onClick={() => navigate("/role-form", {state: {id: params.row.role_id}})}
        >
          {params.value}
        </Link>
      )
    },
    {
      field: "role_product_name",
      headerName: "Producto (Rol)",
      flex: 0.8,
      minWidth: 130,
      renderCell: (params) =>
        params.value ? (
          <Link
            component="button"
            underline="hover"
            onClick={() => navigate("/product-form", {state: {id: params.row.product_id}})}
          >
            {params.value}
          </Link>
        ) : (
          "-"
        )
    },
    {
      field: "scope_description",
      headerName: "Descripción",
      flex: 1.2,
      minWidth: 200,
      renderCell: (params) =>
        params.value ? (
          <Tooltip title={params.value} placement="top" arrow>
            <span style={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>{params.value}</span>
          </Tooltip>
        ) : (
          "-"
        )
    }
  ];

  return (
    <ListView
      columns={columns}
      loading={loading}
      dataGridProps={{
        ...dataGridProps,
        pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS
      }}
    />
  );
};

export default ScopesResolveGrid;
